import React from "react";

const Section14Updates = () => (
  <>
    <h2>14. Updates to This Privacy Policy</h2>
    <p>
    Comparedly Ltd. reserves the right to review and update this Privacy Policy periodically to reflect changes in legal requirements, technological advancements, or evolving business practices. In the event of any material changes to this Privacy Policy, we will make reasonable efforts to notify you, such as by sending a notification to the email address associated with your account or by posting a prominent notice on the Comparedly.com website. The date of the latest revision will be clearly indicated at the beginning of this Privacy Policy. We encourage you to review this Privacy Policy regularly to stay informed about how we are protecting your personal data and any updates that may have been implemented.
    </p>
  </>
);

export default Section14Updates;
